import { Navigate, useLocation } from 'react-router-dom'
import { PageLoader } from '../components/PageLoader'
import { type AuthGateProps } from '../constants/auth'
import { LOADING_LABELS } from '../constants/loading'
import { APP_ROUTES } from '../constants/routes'
import { useAuth } from '../hooks/useAuth'

export function RequireAuth({ children }: AuthGateProps) {
  const { isAuthenticated, isReady } = useAuth()
  const location = useLocation()

  if (!isReady) {
    return <PageLoader variant="screen" label={LOADING_LABELS.session} />
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to={APP_ROUTES.login}
        replace
        state={{ from: location.pathname }}
      />
    )
  }

  return children
}

export function RedirectIfAuthed({ children }: AuthGateProps) {
  const { isAuthenticated, isReady } = useAuth()

  if (!isReady) {
    return <PageLoader variant="screen" label={LOADING_LABELS.session} />
  }
  if (isAuthenticated) return <Navigate to={APP_ROUTES.home} replace />

  return children
}
